
<section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong>Document Generation Master Setup</strong>
      </span>
      <!-- <span style="float:right">
        <a [routerLink]="['/ncd/add/new/document']">
          <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" type="button">
            <i class="fa fa-plus"></i>Add Document</button>
        </a>
      </span> -->
    </div>
    <!-- <section class="card search-box">
      <div class="card-header" data-toggle="collapse" data-target="#search-div">Modify Search <span class="pull-right"><i
            class="fa fa-filter" aria-hidden="true"></i></span> </div>
      <div class="card-block collapse" id="search-div">
        <div class="row">
          <div class="col-lg-12">
            <form>
              <div class="row">
                <div class="col-sm-2">
                  <label>Sr No :</label>
                  <div class="input-group">
                    <select id="documentNo" class="form-control">
                      <option value=null [selected]="true">Select</option>
                      <option *ngFor="let document of documents">
                        {{document?.srNo}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-2">
                  <label>Document Name:</label>
                  <div class="input-group">
                    <select id="documentname" class="form-control">
                      <option value=null [selected]="true">Select</option>
                      <option *ngFor="let document of documents">
                        {{document?.documentName}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-2">
                  <label>&nbsp;&nbsp;&nbsp;</label>
                  <div class="input-group">
                    <button type="button" class="btn btn-sm btn-primary mb-2">
                      <i class="fa fa-search"></i>Search</button>
                    &nbsp;&nbsp;&nbsp;
                    <button type="button" class="btn btn-sm btn-default mb-2">
                      <i class="fa fa-refresh"></i>Clear</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section> -->
    <div class="card-block datatable-card-block" style="margin-top: 20px;">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
              <table datatable [dtOptions]="dtDocumentList" [dtTrigger]="dtTrigger"
                class="table table-hover compact cell-border nowrap stripe" id="ncdDocGenMaster" style="cursor: pointer;">
                <thead>
                  <tr>
                    <th style="width:10px" id="srno">Sr. No </th>
                    <th style="width:250px">Document Name</th>
                    <th style="width:225px">Last Updated At</th>
                    <th style="width: 10px;">
                      <span>Action</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let document of documents; let count=index" style="line-height: 25px;">
                    <td tabindex="1">{{document?.srNo}}</td>
                    <td tabindex="1">
                      <span>{{document?.documentName}}</span>
                    </td>
                    <td tabindex="1">{{document?.updatedAt | date}}</td>
                    <td style='white-space: nowrap'>
                      <a (click) = "editDocumentMaster(document?._id)"  >
                        <button type="button" class="btn-sm btn btn-warning">
                          <span class="fa fa-pencil"></span>
                        </button>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>